import * as core from '../../../../../../../core'

import { query } from './requirements-dashboard-status-bar.query'

export const RESOURCE = {
  payload: {
    alias: 'requirements-dashboard.status-bar',
    description:
      'Requirement count per Jira status, click a bar to filter the table below',
    name: 'Requirements Dashboard - Status Bar',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
